export function isFilePath(files: File[], file_ext: string) {
  return files.length > 0 ? files.filter(obj => obj.file_ext === file_ext) : [];
}